import React from "react";

// SCSS
import styles from "./index.module.scss";

// COMPONENTS
import Text from "../../../Components/FormControl/Text/Text";
import Select from "../../../Components/FormControl/Select/Select";
import WYSIWIGEditor from "../../../Components/WYSIWIGEditor/WYSIWIGEditor";

import { useCmsPage } from "../../../Context/Cms-page/useCmsPage";
import {
  CMS_PAGE_TEMPLATES,
  CMS_PAGE_TEMPLATE_DEFAULT,
} from "../../../Helpers/Constants";

function PrimaryInformation(props) {
  const {
    cmsPageState,
    setPageName,
    setPageSlugName,
    setPageDescription,
    setPageTemplate,
  } = useCmsPage();

  const previewPath =
    cmsPageState.template === CMS_PAGE_TEMPLATE_DEFAULT
      ? `/${cmsPageState.slug}`
      : `/guides/${cmsPageState.slug}`;

  return (
    <form className={`row`}>
      <div className={`${styles.productsWrapper}`} id="primary-information">
        <div className={`mt-2 md-4`}>
          <div className={`row`}>
            <div className={`col-md-6 col-xs-12`}>
              <Text
                type="text"
                label="Page Title"
                value={cmsPageState.title}
                onChange={(data) => setPageName(data)}
                id="title"
              />
            </div>
            <div className={`col-md-6 col-xs-12`}>
              <Text
                type="text"
                label="Slug"
                value={cmsPageState.slug}
                onChange={(data) => setPageSlugName(data)}
                id="slug"
              />
              {cmsPageState.slug ? (
                <p className="text-muted small mb-2">
                  This page will live at {previewPath}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className={`row`}>
            <div className={`col-md-6 col-xs-12 ${styles.templateField}`}>
              <Select
                label="Page Template"
                value={cmsPageState.template}
                options={CMS_PAGE_TEMPLATES}
                required={true}
                onChange={(data) => setPageTemplate(data)}
                disabled={false}
              />
            </div>
          </div>

          <br></br>
          <div className={`row`}>
            <label
              className="bmd-label-floating"
              style={{ marginLeft: "15px" }}
            >
              Description
            </label>
            <div className={`col-md-12 col-xs-12`}>
              <WYSIWIGEditor
                data={cmsPageState.description}
                onChange={(data) => {
                  setPageDescription(data)
                  // BlogFormik.setValues((v) => {
                  //   return { ...v, description: data };
                  // });
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <button
        className="d-none primary-info-submit-button"
        type="submit"
      ></button>
    </form>
  );
}

export default PrimaryInformation;
